import { getAllFromCache, saveAllToCache } from './indexedDBHelper';
import { FilterStateQuestions } from './FilterStateQuestions';
import { AssembleTestQuestions } from './AssembleTestQuestions';

export async function fetchQuestionsHandler({
    selectedOption = 0,
    usedPage = '',
}) {
    try {
        let tableName;
        let cachedData;
        if (usedPage === 'StatePage') {
            tableName = process.env.REACT_APP_STATE_QUESTIONS_TB;
            const fetchData = await getAllFromCache(tableName);
            cachedData = FilterStateQuestions(selectedOption, fetchData);
        } else if (usedPage === 'TestPage') {
            // tableName = process.env.REACT_APP_TEST_QUESTIONS_TB;
            cachedData = await AssembleTestQuestions(selectedOption);
        } else {
            tableName = process.env.REACT_APP_GENERAL_QUESTIONS_TB;
            cachedData = await getAllFromCache(tableName);
        }
        // Check cache
        // const resolvedData = await Promise.resolve(cachedData);
        if ((await cachedData) && (await cachedData).length > 0) {
            // console.log(`Using cached data from ${tableName}`);
            if (usedPage === 'TestPage' && cachedData.length === 33) {
                return cachedData;
            }
            if (usedPage !== 'TestPage') {
                return cachedData; //.map((item) => item.value); // Return values only
            }
        }

        // Build the URL
        let url =
            // process.env.REACT_APP_AWS_APIGATEWAY_URL ||
            process.env.REACT_APP_HOSTINGER_API_URL ||
            process.env.REACT_APP_LOCAL_API_URL;
        if (usedPage === 'StatePage') {
            url += `/QuestionsData/GetQuestionsEachState/${selectedOption}`;
        } else if (usedPage === 'TestPage') {
            url += `/QuestionsData/GetTestSet/${selectedOption}`;
        } else {
            url += `/QuestionsData/GetAllGeneralQuestions`;
        }

        // Fetch data from API
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Error fetching questions: ${response.statusText}`);
        }

        const data = await response.json(); // it is the body of response, so it is a list

        // Save fetched data to cache
        if (usedPage !== 'TestPage') {
            await saveAllToCache(tableName, data);
        }

        return data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error;
    }
}
